@if (effectivenessOverviewConfig) {
    <generic-grouped-list-manager [config]="effectivenessOverviewConfig">
    </generic-grouped-list-manager>
}
